<app-service-settings-common
    [settingsKey]="SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY"
    [title]="'service.settings.care-plan.header'"
></app-service-settings-common>
